export const state = {
  // product: undefined,
  // products: []
  prix: {},
  prixs: [],
  pagination:''
}
